import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import type { PaginatedData } from '../../shared/utils/pagination.utils'
import { mapToPaginatedData } from '../../shared/utils/pagination.utils'
import { ApiService } from '../api.service'
import { completeDataOrThrow } from '../complete-data.operator'
import type { EditionDto, Pagination } from '../responses'

@Injectable({
  providedIn: 'root',
})
export class EditionsService {
  private readonly apiService = inject(ApiService)

  getEditionsByMagazineId(
    magazineId: number
  ): Observable<PaginatedData<EditionDto>> {
    const pagination: Pagination = { page: 1, limit: 1000 } // Large limit to get all editions
    const queryRef = this.apiService.getEditionsByMagazineId(
      magazineId,
      pagination
    )
    return queryRef.valueChanges.pipe(
      completeDataOrThrow(),
      map(result => mapToPaginatedData(result.data.Editions))
    )
  }

  getEditionById(id: number): Observable<EditionDto> {
    return this.apiService
      .getEditionById(id)
      .pipe(map(result => result.data.Edition))
  }

  downloadEditionPdf(id: number): Observable<Blob> {
    return this.apiService.downloadEdition(id)
  }
}
